<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-randomad__randomad}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="请输入ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.title" placeholder="请输入标题" clearable></el-input>
        </el-form-item>
        <el-form-item>
         <el-select v-model="dataForm.status" placeholder="请选择状态" clearable>
           <el-option label="启用" :value="1"></el-option>
           <el-option label="禁用" :value="0"></el-option>
         </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('randomad:randomad:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('randomad:randomad:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-popover
            placement="bottom"
            width="300"
            trigger="click"
            v-model="columnFilterVisible">
            <div class="column-filter-panel">
              <div class="filter-header">
                <span>列显示设置</span>
                <el-button type="text" size="small" @click="resetColumns">重置</el-button>
              </div>
              <el-checkbox-group v-model="selectedColumns" class="filter-checkboxes">
                <el-checkbox
                  v-for="col in allColumns"
                  :key="col.prop"
                  :label="col.prop"
                  :disabled="col.required">
                  {{ col.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <el-button slot="reference" icon="el-icon-setting">列筛选</el-button>
          </el-popover>
        </el-form-item>
        <el-form-item label="随机广告位开关">
          <el-switch
              v-model="enableRandomAd"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              @change="handleEnableSwitch"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" :fit="true" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column v-if="isColumnVisible('id')" prop="id" label="ID" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('title')" prop="title" label="标题" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('url')" prop="url" label="跳转地址" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('img')" prop="img" label="广告图片" header-align="center" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.img" width="160" height="90" alt=""/>
          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('hitCount')" prop="hitCount" label="点击数" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('orderNo')" prop="orderNo" label="排序" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('createDate')" prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('updateDate')" prop="updateDate" label="更新时间" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('status')" prop="status" label="状态" header-align="center" align="center">
          <template v-slot:="scope">
            <el-button plain size="mini" :type="scope.row.status==1?'success':'danger'" @click="switchStatus(scope.row.id,scope.row.status==0?1:0)">{{ formatStatus(scope.row.status) }}</el-button>

          </template>
        </el-table-column>
<!--
        <el-table-column prop="expiredDate" label="到期时间" width="200" header-align="center" align="center"></el-table-column>
-->
        <el-table-column v-if="isColumnVisible('comment')" prop="comment" label="备注" header-align="center" align="center"></el-table-column>

        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('randomad:randomad:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-tooltip :content="scope.row.status === 1 ? '启用状态的广告不能删除，请先禁用' : '删除'" placement="top">
              <span>
                <el-button
                  v-if="$hasPermission('randomad:randomad:delete')"
                  type="text"
                  size="small"
                  :disabled="scope.row.status === 1"
                  @click="deleteHandle(scope.row.id)">
                  {{ $t('delete') }}
                </el-button>
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './randomad-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      enableRandomAd:0,
      mixinViewModuleOptions: {
        getDataListURL: '/randomad/randomad/page',
        getDataListIsPage: true,
        exportURL: '/randomad/randomad/export',
        deleteURL: '/randomad/randomad',
        switchStatusUrl:'/randomad/randomad/switch-status',
        deleteIsBatch: true
      },
      operOptions:[{
        value: 'enable',
        label: '启用'
      },{
        value: 'disable',
        label: '禁用'
      }],
      dataForm: {
        id: '',
        title: '',
        status: ''
      },
      // 列筛选相关
      columnFilterVisible: false,
      allColumns: [
        { prop: 'id', label: 'ID', required: false },
        { prop: 'title', label: '标题', required: false },
        { prop: 'url', label: '跳转地址', required: false },
        { prop: 'img', label: '广告图片', required: false },
        { prop: 'hitCount', label: '点击数', required: false },
        { prop: 'orderNo', label: '排序', required: false },
        { prop: 'createDate', label: '创建时间', required: false },
        { prop: 'updateDate', label: '更新时间', required: false },
        { prop: 'status', label: '状态', required: false },
        { prop: 'comment', label: '备注', required: false }
      ],
      selectedColumns: []
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.initSelectedColumns()
    this.$http.get("/randomad/randomad/get-random-ad-status").then(({data:res})=>{

      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
     // debugger
      this.enableRandomAd=res.data;
    })
  },
  watch: {
    selectedColumns: {
      handler() {
        this.saveColumnSettings()
      },
      deep: true
    }
  },
  methods:{
    // 初始化选中的列
    initSelectedColumns() {
      const savedColumns = localStorage.getItem('randomad_selected_columns')
      if (savedColumns) {
        this.selectedColumns = JSON.parse(savedColumns)
      } else {
        this.selectedColumns = this.allColumns.map(col => col.prop)
      }
    },

    // 判断列是否可见
    isColumnVisible(prop) {
      return this.selectedColumns.includes(prop)
    },

    // 重置列设置
    resetColumns() {
      this.selectedColumns = this.allColumns.map(col => col.prop)
      this.saveColumnSettings()
      this.$message.success('已重置列显示设置')
    },

    // 保存列设置
    saveColumnSettings() {
      localStorage.setItem('randomad_selected_columns', JSON.stringify(this.selectedColumns))
    },
    handleOperChange(val){
      console.log("handleOperChange",val)
      switch (val){
        case "enable":{
          this.switchStatus(null,1)
        }break;
        case "disable":{
          this.switchStatus(null,0)
        }break;
      }
    },
    handleEnableSwitch(val){
      this.$http.get("/randomad/randomad/enable-random-ad/"+val).then(({data:res})=>{
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
      })
    },
    formatStatus(status) {
       return status === 1 ? '启用' : '禁用'
    }

  }
}
</script>

<style lang="scss" scoped>
.column-filter-panel {
  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ebeef5;

    span {
      font-weight: 600;
      color: #303133;
    }
  }

  .filter-checkboxes {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .el-checkbox {
      margin-right: 0;
      margin-left: 0;
    }
  }
}
</style>
